




































































import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import { Message } from "element-ui";
import {imageUrl} from '@/utils/common'
@Component({})
export default class AUser extends Vue {
  pickerOptions = {
      shortcuts: [{
        text: '最近一周',
        onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  // 表格数据
  tableData = [];
  // 加载状态
  loading = false;
  btnloading = false
  // 总条数
  total = 0;

  isDialog = false;
  list: any = [];

  // 搜索条件
  search = {
    keyword: '',
    companyName: '',
    sendLetterTimes: [],
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };


  //上传
  fileList: any = [];
  formData = "";
  delFile() {
    this.fileList = [];
  }

  getBase64(file: any) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      let imgResult: any = "";
      reader.readAsDataURL(file);
      reader.onload = function() {
        imgResult = reader.result;
      };
      reader.onerror = function(error) {
        reject(error);
      };
      reader.onloadend = function() {
        resolve(imgResult);
      };
    });
  }

  protected handleExceed(res: any) {
    Message.error({
      message: res,
      duration: 5 * 1000,
    });
  }
  baseInfo = ''
  handleChange(file: any, fileList: any) {
    console.log('file', file)
    // var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
    // console.log('testmsg', testmsg)
    // const extension = testmsg === 'xlsx'
    // if(!extension) {
    //   this.$message({
    //     message: '上传文件只能是xlsx格式!',
    //     type: 'warning'
    //   });
    //   this.fileList = [];
    //   return
    // }
    this.getBase64(file.raw).then((res: any) => {
      this.baseInfo = res.split(',')[1]
    })
  }
  handleRemove(file: any, fileList: any) {
    console.log(file, fileList);
  }
  handlePreview(file: any) {

  }
  uploadFile(file: any) {
    (this.formData as any).append("file", file.file);
    this.submitUpload()
  }
  submitUpload() {
    let formData = new FormData();
    formData.append("file", (this.fileList[0] as any).raw);
  }

  save() {
    let obj = {
      base64File: this.baseInfo,
    };
    api.post("J27543", obj).then((res) => {
      this.$message.success("上传成功");
      this.addDialog = false;
      this.fileList = [];
      this.searchTable()
    }).finally(() => {
    })
  }






  addDialog = false
  add() {
      this.addDialog = true
  }

  // toRecord(id: any) {
  //   this.$emit('toRecord', id)
  // }

  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0,
      };
    }
    api
      .post("J27544", this.search)
      .then((data) => {
        this.total = data.total;
        this.tableData = data.records;

      })
      .finally(() => {
        this.loading = false;
      });
  }

  // 交易中心
  channel = []
  getChannelDict() {
    api
      .post('A13005')
      .then(res => {
        this.channel = res
        this.searchTable()
      })
  }

  config: any = {}
  getConf() {
    api.getConf().then((res) => {
      this.config = res
      this.getChannelDict()
    })
  }

  activated() {
    this.getConf()

  }

}
